export default "__VITE_ASSET__418608a5__$_?nuxt_component=async__"